import { LocTagInvite } from 'src/types/LineOfCredit';
import { transformDollarToPennies } from 'src/utilities/currency-utils';

export function cleanAmount(amount: string): number {
  return transformDollarToPennies(Number(amount));
}

export function getGroupBudgetsPayload(
  tagInvites: LocTagInvite[] = []
): Record<string, number> {
  return tagInvites.reduce(
    (obj, item) => ({ ...obj, [item.id]: item.budget }),
    {}
  );
}

export function filterOutGroupById(
  tagInvites: LocTagInvite[],
  groupId: string
): LocTagInvite[] {
  return tagInvites.filter(({ id }) => id !== groupId);
}
